import styled, { css } from 'styled-components';
import '../../utils/assertions.es.js';
import 'react';
import '../../utils/responsive.es.js';
import '../../utils/scrollIntoView.es.js';
import { spacing } from '../../utils/theme.es.js';
import '../../utils/useEnhancedEffect.es.js';
import 'react-is';
import { Box } from '../../primitives/Box/Box.es.js';

const Tiles = styled(Box)`
    display: grid;
    grid-template-columns: ${({ columns }) => `repeat(${columns}, 1fr)`};
    grid-auto-rows: 1fr;
    place-items: start;
    gap: ${({ gutter }) => spacing(gutter || "md")};
    ${({ direction, rows }) => direction === "vertical" && css`
        grid-auto-flow: column;
        grid-template-rows: repeat(${rows}, 0fr);
    `}
`;

export { Tiles };
//# sourceMappingURL=styled.es.js.map
